export function randIntInRange(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function lngSupportsAdvancedTextRenderer() {
  return (
    (window as any).lng &&
    (window as any).lng.textures.TextTexture &&
    Object.getOwnPropertyDescriptor((window as any).lng.textures.TextTexture.prototype, 'advancedRenderer')
  );
}
